module.exports = __webpack_public_path__ + "img/contabilidad.7c71f637.png";